/**
 * Module dependencies.
 */

import React, { ReactNode } from 'react';
import { cn } from 'app/lib/utils';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  isIncome: boolean;
  noBreak?: boolean;
  isCurrency?: boolean;
  children: ReactNode;
};

/**
 * Export `BudgetLabel` component.
 */

export function BudgetLabel({ className, isCurrency, noBreak, isIncome, children }: Props): JSX.Element {
  return (
    <span
      className={cn(className, {
        'text-[rgb(130,201,130)] font-medium': isIncome,
        "font-['Oswald']": isCurrency,
        'whitespace-nowrap': noBreak
      })}
    >
      {children}
    </span>
  );
}
